module.exports = __webpack_public_path__ + "static/images/3_rainy_taxi_day.cec72776.jpg";